import React, { HTMLProps, useState } from "react";

/**
 * We extend `<img>`'s properties as we want our
 * component to act as a drop-in replacement for it
 */
type ImgProps = HTMLProps<HTMLImageElement> & {
  /**
   * Optional fallback to render in place of a missing image
   * @default null
   */
  alt?: string;
  fallback?: JSX.Element;
};
const ImgWithPlaceholder = (props: ImgProps) => {
  const { fallback, alt } = props;

  /**
   * is our image broken?
   */
  const [isBroken, setIsBroken] = useState(false);

  const handleError = () => {
    setIsBroken(true);
  };

  if (isBroken) {
    return fallback || <></>;
  }

  return <img onError={handleError} alt={alt} {...props} />;
};

export default ImgWithPlaceholder;
